<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-6">
      <h4 i18n>Finalizar pedido</h4>
      <p class="pl-1 mb-4" i18n>Verifique os dados para finalizar!</p>
    </div>
    <div *ngIf="pedido && pedido.itens.length" class="col-6 text-right">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label
          (click)="toRoute(1)"
          [class.active]="modo == 1"
          class="btn btn-primary"
        >
          <input
            type="radio"
            name="options"
            id="option1"
            autocomplete="off"
          /><i class="icofont-list"></i>
        </label>
        <label
          (click)="toRoute(2)"
          [class.active]="modo == 2"
          class="btn btn-primary"
        >
          <input
            type="radio"
            name="options"
            id="option3"
            autocomplete="off"
          /><i class="icofont-listing-number"></i>
        </label>
      </div>
    </div>
  </div>
  <div *ngIf="!pedido" class="col-lg-6 offset-lg-3 text-center">
    <h5 i18n>Selecione um Pedido!</h5>
    <img src="assets/empty.png" class="img-fluid" />
  </div>
  <div *ngIf="pedido" class="col-lg-12">
    <div class="row mt-2 mb-2">
      <div class="col-sm-1">
        <label i18n>Código</label><br />
        {{ pedido.id }}
      </div>
      <div class="col-sm-5">
        <label
          ><input
            type="checkbox"
            value="true"
            [(ngModel)]="pedidoClienteSelected.todos"
            (change)="changePedidoClienteSelectedTodos()"
          />
          {{ SITE.labelCliente }}</label
        ><br />
        <div *ngFor="let pc of pedido.clientes">
          <label style="font-size: inherit">
            <input
              type="checkbox"
              value="true"
              [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
              (change)="changePedidoClienteSelected()"
            />
            {{ pc.cliente[SITE.identificacaoCliente] }} -
            {{ pc.cliente.nome }}
          </label>
          <a
            *ngIf="pedido.tipo.aprovacaoCliente"
            (click)="getLinkAprovaCliente(pc.id)"
            style="cursor: pointer"
          >
            <span
              *ngIf="pc.aprovado; else elseBlockAprvCli"
              style="color: green"
              >&nbsp; <b><u>APROVADO</u></b></span
            >
            <ng-template #elseBlockAprvCli
              ><span style="color: orange"
                >&nbsp; <b><u>AGUARDANDO</u></b></span
              >
            </ng-template>
          </a>
        </div>
      </div>
      <div class="col-sm-3">
        <label>{{ SITE.labelFilial }}</label
        ><br />
        <div class="form-group">
          <div class="row">
            <div class="col-10 p-0">
              <select
                class="form-control form-control-sm"
                [(ngModel)]="pedido.filial.id"
                [ngModelOptions]="{ standalone: true }"
              >
                <option *ngFor="let f of filiais" value="{{ f.id }}">
                  {{ f.codigo }} - {{ f.descricao }}
                </option>
              </select>
            </div>
            <div
              *ngIf="filiais.length > 1 && !pedido.salvoCheckout"
              class="col-2 pl-1"
            >
              <button
                (click)="savePedidoFilial()"
                class="btn btn-primary btn-sm"
              >
                <i class="icofont-ui-edit"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <label i18n>Tabela</label><br />
        {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="col-sm-1" *ngIf="limiteCredito && limiteCredito !== null">
        <label i18n>Limite de crédito</label><br />
        R$ {{ limiteCredito | currency : "BRL" : "" }}
      </div>
      <div class="col-sm-5"></div>
      <div class="col-sm-3">
        <label>{{ SITE.labelPedidoTipo }}</label
        ><br />
        <div class="form-group">
          <div class="row align-items-center">
            <div class="col-10 p-0">
              <select
                class="form-control form-control-sm"
                [(ngModel)]="pedido.tipo.id"
                [ngModelOptions]="{ standalone: true }"
              >
                <option *ngFor="let t of pedidoTiposUsuario" value="{{ t.id }}">
                  {{ t.tipo }} - {{ t.descricao }}
                </option>
              </select>
            </div>
            <div *ngIf="pedidoTiposUsuario.length > 1" class="col-2 pl-1">
              <button (click)="savePedidoTipo()" class="btn btn-primary btn-sm">
                <i class="icofont-ui-edit"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!pedidoItens.length" class="row">
      <div class="col-lg-6 offset-lg-3 text-center">
        <img src="assets/empty.png" style="height: 230px" class="img-fluid" />
        <h4 i18n>Selecione alguns produtos!</h4>
      </div>
    </div>
    <div *ngIf="pedidoItens.length">
      <div class="table-responsive">
        <table
          *ngIf="modo == 1"
          class="table table-hover table-condensed table-striped table-sm table-responsive-xs"
        >
          <thead class="table-head">
            <tr>
              <th></th>
              <th><label i18n>Produto</label></th>
              <th *ngIf="pedido.tipo.validaEstoque">
                <label i18n>Estoque</label>
              </th>
              <th><label i18n>Quant.</label></th>
              <th><label i18n>R$ Preço</label></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pedidoItens">
              <td>
                <a
                  *ngIf="item.nome; else elseBlockImg"
                  href="javascript:void(0);"
                  routerLink="/produto/{{ item.produto }}"
                  ><img
                    src="{{ API_IMAGENS_PRODUTOS }}{{ item.nome }}"
                    class="img-fluid"
                    style="max-width: 50px"
                /></a>
                <ng-template #elseBlockImg
                  ><img
                    src="assets/no-product-image.jpg"
                    class="img-fluid"
                    style="max-width: 50px"
                /></ng-template>
              </td>
              <td>
                {{ item.produtoReferencia }} - {{ item.produtoDescricao }}
              </td>
              <td *ngIf="pedido.tipo.validaEstoque">
                <div>
                  <!-- <simple-html
                    [html]="checkErrorEstoque(item.produto)"
                  ></simple-html> -->
                  <i
                    *ngIf="checkErrorEstoque(item); else elseBlockIcn"
                    class="icofont-close"
                    style="color: red; font-size: 25px"
                    ></i>
                    <ng-template #elseBlockIcn>
                      <i
                      class="icofont-check"
                      style="color: green; font-size: 28px"
                    ></i>
                  </ng-template>
                </div>
              </td>
              <td>{{ item.quantidade }}</td>
              <td i18n>
                R$
                {{
                  this.SITE.mostraImpostoDetalhado
                    ? (item.total | currency : "BRL" : "")
                    : (item.total + item.quantidade * item.imposto
                      | currency : "BRL" : "")
                }}
              </td>
              <td class="text-center align-middle">
                <button
                  routerLink="/produto/{{ item.produto }}"
                  *ngIf="!pedido.salvoCheckout"
                  title="Editar"
                  class="btn btn-outline-primary"
                >
                  <i class="icofont-ui-edit"></i>
                </button>
              </td>
              <td class="text-center align-middle">
                <button
                  (click)="confirmDel(item.produto)"
                  data-toggle="modal"
                  data-target="#confirmDelModal"
                  title="Excluir"
                  class="btn btn-outline-primary"
                >
                  <i class="icofont-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td *ngIf="pedido.tipo.validaEstoque"></td>
              <td>
                <b>{{ pedidoItensQuantSum }}</b>
              </td>
              <td>
                <!-- <b>{{
                  valorTotal -
                  retornaNumero(this.form.controls.freteValor.value)
                  | currency : "BRL" : ""
                  }}</b> -->
                <b i18n>R$ {{ subTotal | currency : "BRL" : "" }}</b>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table
          *ngIf="modo == 2"
          class="table table-hover table-condensed table-striped table-sm table-responsive-xs"
        >
          <thead class="table-head">
            <tr>
              <th></th>
              <th><label i18n>Produto</label></th>
              <th><label i18n>Cor</label></th>
              <th><label i18n>Estampa</label></th>
              <th><label i18n>Tamanho</label></th>
              <th>
                <label *ngIf="this.SITE.mostraEstoqueDigitacao">Estoque</label>
              </th>
              <th><label i18n>Quant.</label></th>
              <th><label i18n>R$ Preço</label></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pedidoItens">
              <td>
                <a
                  *ngIf="item.nome; else elseBlockImg"
                  href="javascript:void(0);"
                  routerLink="/produto/{{ item.produto }}"
                  ><img
                    src="{{ API_IMAGENS_PRODUTOS }}{{ item.nome }}"
                    class="img-fluid"
                    style="max-width: 50px"
                /></a>
                <ng-template #elseBlockImg
                  ><img
                    src="assets/no-product-image.jpg"
                    class="img-fluid"
                    style="max-width: 50px"
                /></ng-template>
              </td>
              <td>{{ item.produtoReferencia }} - {{ item.descricao }}</td>
              <td>{{ item.corDescricao }}</td>
              <td>{{ item.estampaDescricao }}</td>
              <td>{{ item.tamanho }}</td>
              <td>
                <div
                  *ngIf="
                    this.SITE.mostraEstoqueDigitacao
                  "
                >
                <td>
                  <span *ngIf="checkErrorEstoque(item); else elseBlockEstoque" style="color: red;">
                    <b>
                      {{ item.estoque}}
                    </b>
                  </span>
                  <ng-template #elseBlockEstoque>
                    <span style="color: blue;">
                      <b>
                        {{ item.estoque}}
                      </b>
                    </span>
                    </ng-template>
                      
                </div>
              </td>
              <td>{{ item.quantidade }}</td>
              <td i18n>R$ {{ item.total | currency : "BRL" : "" }}</td>
              <td class="text-center align-middle">
                <button
                  routerLink="/produto/{{ item.produto }}"
                  *ngIf="!pedido.salvoCheckout"
                  title="Editar"
                  class="btn btn-outline-primary"
                >
                  <i class="icofont-ui-edit"></i>
                </button>
              </td>
              <td class="text-center align-middle">
                <button
                  (click)="confirmDelModo2(item.id)"
                  data-toggle="modal"
                  data-target="#confirmDelModalModo2"
                  title="Excluir"
                  class="btn btn-outline-primary"
                >
                  <i class="icofont-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <b>{{ pedidoItensQuantSum }}</b>
              </td>
              <td>
                <b i18n>R$ {{ pedidoItensPrecoSum | currency : "BRL" : "" }}</b>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <form *ngIf="!fatalError" (ngSubmit)="onSubmit()" [formGroup]="form">
        <div class="col-lg-12">
          <div
            *ngIf="this.subTotal < this.SITE.valorMinimoPedido"
            class="alert alert-danger"
            role="alert"
            i18n
          >
            {{
              "Valor do pedido inferior ao mínimo estipulado de R$ " +
                SITE.valorMinimoPedido +
                "!"
            }}
          </div>
          <div *ngIf="error" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
          <div *ngIf="worningMessage" class="alert alert-primary" role="alert">
            {{ worningMessage }}
          </div>
          <div class="row">
            <div class="col-lg-4 pl-0">
              <div class="form-group">
                <label i18n>Forma de pagamento</label>
                <select
                  id="formaPagamento"
                  formControlName="formaPagamento"
                  (change)="changeFormaPagamento()"
                  class="form-control"
                >
                  <option value="">...</option>
                  <option
                    *ngFor="let t of formaPagamento"
                    value="{{ t.forma_pagamento_id }}"
                  >
                    {{ t.forma_pagamento }}
                  </option>
                </select>
                <!-- <select id="formaPagamento" formControlName="formaPagamento" (change)="changeFormaPagamento()"
                  class="form-control">
                  <option value="">...</option>
                  <option *ngFor="let t of formaPagamento" value="{{ t.forma_pagamento_id }}">
                    {{ t.forma_pagamento }}
                  </option>
                </select> -->
                <div
                  *ngIf="error && form.get('formaPagamento').invalid"
                  class="error"
                  i18n
                >
                  Verifique este campo!
                </div>
              </div>
              <div class="form-group" *ngIf="usaTipoPedido">
                <label i18n>Tipo de pagamento</label>
                <select
                  id="tipoPagamento"
                  formControlName="tipoPagamento"
                  (change)="changeTipoPagamento()"
                  class="form-control"
                >
                  <option value="">...</option>
                  <option *ngFor="let t of tipoPagamento" value="{{ t.id }}">
                    {{ t.descricao }}
                  </option>
                </select>
              </div>
              <div *ngIf="uploadFile > 0" class="mb-3">
                <label>Arquivo(s)</label><br />
                <ul class="list-group">
                  <li class="list-group-item">
                    <label
                      class="btn btn-secondary btn-sm float-right"
                      for="my-file-selector"
                    >
                      <input
                        id="my-file-selector"
                        (change)="onSelectedFile($event)"
                        type="file"
                        class="d-none"
                      />
                      <i class="icofont-upload-alt"></i> Selecione
                    </label>
                  </li>
                  <li
                    *ngFor="let f of files; let i = index"
                    class="list-group-item list-group-item-action"
                  >
                    <div
                      (click)="onRemoveFile(i)"
                      class="float-right"
                      style="cursor: pointer; color: #888"
                    >
                      XxxxxX
                    </div>
                    {{ f.name }}
                  </li>
                </ul>
              </div>
              <div class="form-group">
                <label i18n>Observações</label>
                <textarea
                  formControlName="observacao"
                  name="observacao"
                  rows="8"
                  class="form-control"
                ></textarea>
              </div>
              <div *ngIf="pedido.tipo.obsNotaFiscal" class="form-group">
                <label i18n>Observações Nota Fiscal</label>
                <textarea
                  formControlName="observacaoNota"
                  name="observacaoNota"
                  rows="5"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-4 pl-0">
              <app-credit-card
                *ngIf="isCartaoCredito()"
                class="align-right"
                [pedido]="this.pedidoService.pedido.id"
                [currentFormaPagamento]="this.currentFormaPagamento"
              ></app-credit-card>

              <div *ngIf="clienteIdErp || tipoFrete" class="col-lg-12">
                <table
                  *ngIf="clienteIdErp && !pedido.tipo.permiteDigitacaoCep"
                  class="table table-hover table-condensed mb-0"
                  style="margin-left: 0px; width: 400px"
                >
                  <thead>
                    <tr>
                      <td class="p-1" colspan="2" i18n>
                        Endereço de entrega<br />
                        <div *ngIf="pedido.clientes.length > 1" class="mb-3">
                          <span
                            *ngFor="let c of pedido.clientes"
                            class="badge badge-primary mr-2"
                            tooltip="{{
                              c.cliente['cliente' + SITE.identificacaoCliente]
                            }}"
                            style="cursor: pointer"
                            placement="bottom"
                          >
                            <span
                              (click)="selecionaCliente(c.cliente)"
                              (click)="
                                calculaFrete(
                                  this.form.controls.freteCepDestino.value
                                )
                              "
                              class="descr"
                              >{{ c.cliente[SITE.identificacaoCliente] }}</span
                            >
                          </span>
                        </div>
                      </td>
                    </tr>
                  </thead>
                  <tbody *ngIf="selectedCliente.enderecos.length > 0">
                    <tr *ngFor="let a of selectedCliente.enderecos">
                      <td style="width: 40px">
                        <input
                          type="radio"
                          [disabled]="pedido.salvoCheckout"
                          (click)="calculaFrete(a.cep)"
                          value="{{ a.idenderecoerp }}"
                          [formControl]="form.controls['idEndereco']"
                        />
                      </td>
                      <td>
                        <h6>{{ a.endereco }} {{ a.numero }}</h6>
                        {{ a.uf }} - {{ a.nomecidade }} ({{ a.cep }}),
                        {{ a.bairro }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="tipoFrete == 1">
                  <div class="row">
                    <div class="col-lg-w pl-0">
                      <div class="form-group" style="margin-right: 20px">
                        <label i18n>CEP</label>
                        <input
                          type="text"
                          [formControl]="form.controls['freteCepDestino']"
                          mask="00000-000"
                          class="form-control"
                        />
                        <div
                          *ngIf="error && form.get('freteCepDestino').invalid"
                          class="error"
                          i18n
                        >
                          Verifique este campo!
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-w pr-0" style="margin-left: 20px">
                      <div
                        *ngIf="pedido.tipo.modalidadeFreteCF"
                        class="form-group"
                        style="margin-left: 50px; display: none"
                      >
                        <label style="margin-left: 20px" i18n
                          >Modalidade frete</label
                        ><br />
                        <label
                          ><input
                            type="radio"
                            value="0"
                            formControlName="freteModalidade"
                            (click)="onFreteModalidade('0')"
                          />
                          CIF</label
                        >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label
                          ><input
                            type="radio"
                            value="1"
                            formControlName="freteModalidade"
                            (click)="onFreteModalidade('1')"
                          />
                          FOB</label
                        ><br />
                        <div
                          *ngIf="error && form.get('freteModalidade').invalid"
                          class="error"
                          i18n
                        >
                          Verifique este campo!
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 pl-0">
                      <div class="form-group">
                        <label i18n>R$ Valor Frete</label>
                        <input
                          type="text"
                          formControlName="freteValor"
                          class="form-control"
                          (blur)="maskMoneyBlur()"
                          (keyup)="maskMoney($event)"
                        />
                        <div
                          *ngIf="error && form.get('freteValor').invalid"
                          class="error"
                          i18n
                        >
                          Verifique este campo!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="tipoFrete == 2"
                  style="margin-left: 0px; width: 400px"
                >
                  <div *ngIf="!freteShow">
                    <label>&nbsp;</label>
                    <div class="alert alert-info" role="alert" i18n>
                      Informe uma forma de pagamento.
                    </div>
                  </div>
                  <div *ngIf="freteShow">
                    <!-- {{ pedido.tipo.permiteDigitacaoCep }}
                    {{ freteShow }} -->
                    <div class="row">
                      <div class="col-lg-w pl-0">
                        <div
                          class="form-group"
                          *ngIf="pedido.tipo.permiteDigitacaoCep"
                        >
                          <label i18n>CEP</label>
                          <div class="input-group">
                            <input
                              type="text"
                              mask="00000-000"
                              [readonly]="!pedido.tipo.permiteDigitacaoCep"
                              [formControl]="form.controls['freteCepDestino']"
                              class="form-control"
                              style="display: ''"
                            />
                            <div class="input-group-append">
                              <button
                                type="button"
                                (click)="
                                  calculaFrete(
                                    this.form.controls.freteCepDestino.value
                                  )
                                "
                                class="btn btn-secondary"
                                style="display: ''"
                                i18n
                              >
                                {{ calculando ? "Calculando..." : "calcular" }}
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="error && form.get('freteCepDestino').invalid"
                            class="error"
                            i18n
                          >
                            Verifique este campo!
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 pr-0">
                        <div
                          *ngIf="pedido.tipo.modalidadeFreteCF && false"
                          class="form-group"
                        >
                          <label i18n>Modalidade frete</label><br />
                          <label *ngIf="cifPermited"
                            ><input
                              type="radio"
                              value="0"
                              formControlName="freteModalidade"
                              [checked]="!fobPermited"
                              (click)="onFreteModalidade('0')"
                            />
                            CIF</label
                          >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label *ngIf="fobPermited"
                            ><input
                              type="radio"
                              value="1"
                              formControlName="freteModalidade"
                              [checked]="!cifPermited"
                              (click)="onFreteModalidade('1')"
                            />
                            FOB</label
                          ><br />
                          <div
                            *ngIf="error && form.get('freteModalidade').invalid"
                            class="error"
                            i18n
                          >
                            Verifique este campo!
                          </div>
                        </div>
                      </div>
                    </div>

                    <label i18n *ngIf="fretes.retirar.length > 0"
                      >Entrega</label
                    >
                    <br />
                    <button
                      type="button"
                      *ngIf="fretes.retirar.length > 0"
                      id="calc"
                      (click)="switchReceber()"
                      class="btn btn-secondary"
                      style="width: 41%; margin-right: 10px"
                      [style.backgroundColor]="!retirar ? '#1c5c46' : '#868e96'"
                      i18n
                    >
                      Receber
                    </button>

                    <button
                      type="button"
                      id="btn-retirar"
                      (click)="mostrarTabela()"
                      *ngIf="fretes.retirar.length > 0"
                      class="btn btn-secondary"
                      style="width: 41%"
                      [style.backgroundColor]="retirar ? '#1c5c46' : '#868e96'"
                      i18n
                    >
                      Retirar
                    </button>
                    <div class="form-group">
                      <div
                        class="btn-group btn-group-toggle"
                        data-toggle="buttons"
                        style="width: 100%"
                      >
                        <div
                          *ngIf="!freteSalvoDescr"
                          class="float-right"
                          style="color: #888"
                        ></div>
                        <!-- <div
                          *ngIf="!fretes.retirar"
                          class="alert alert-info"
                          role="alert"
                          id="aviso"
                          style="display: flex"
                        >
                          <div
                            *ngIf="
                              freteSalvoDescr;
                              else elseBlockFreteSalvoDescr
                            "
                          >
                            {{ freteSalvoDescr }}
                          </div>
                          <ng-template #elseBlockFreteSalvoDescr>
                            <div *ngIf="errorFrete" i18n>
                              Frete não poderá ser calculado!
                            </div>
                            <div *ngIf="!errorFrete" i18n>
                              Informe o CEP acima e realize o cálculo.
                            </div>
                          </ng-template>
                          <br />
                        </div> -->
                        <br />

                        <div
                          class="form-group"
                          id="divfrete"
                          style="
                            cursor: pointer;
                            display: none;
                            margin-top: 1rem;
                            width: 100%;
                          "
                        >
                          <label for="freteId"> Frete </label>
                          <div
                            _ngcontent-rdo-c11=""
                            class="float-right ng-star-inserted"
                            style="color: #888"
                          >
                            <small _ngcontent-rdo-c11=""
                              >Selecione uma opção</small
                            >
                          </div>
                          <!-- <select id="receber" formControlName="freteId" (change)="onFrete($event.target.value)"
                            class="form-control" style="display: none; width: 100%">
                            <option value="">...</option>
                            <option *ngFor="let f of fretes.receber" value="{{ f.id }}" i18n>
                              {{ f.valor === 0 ? "Grátis" : "R$" + f.valor }} -
                              {{ f.label }} - {{ f.labelPrazo }}
                            </option>
                          </select> -->

                          <ul id="receber" style="padding: 0">
                            <li
                              style="padding: 0.5rem 0.75rem"
                              *ngFor="let f of fretes.receber"
                              class="list-group-item list-group-item-action"
                              (click)="onFrete(f.id)"
                            >
                              <div *ngIf="f.error; else elseBlockFrete">
                                <span style="padding: 30px">{{
                                  f.message | json
                                }}</span
                                ><br />
                                <span style="padding: 30px">{{ f.label }}</span>
                              </div>
                              <ng-template #elseBlockFrete>
                                <input
                                  style="display: none !important; width: 25px"
                                  type="radio"
                                  value="{{ f.id }}"
                                  formControlName="freteId"
                                />
                                <div class="d-flex row">
                                  <div class="col-1">
                                    <div
                                      class="mt-1 {{
                                        form.controls.freteId.value == f.id
                                          ? 'selected-radio'
                                          : 'unselected-radio'
                                      }}"
                                    >
                                      <div
                                        *ngIf="
                                          form.controls.freteId.value == f.id
                                        "
                                        class="selected-radio-inside"
                                      ></div>
                                    </div>
                                  </div>
                                  <div class="col">
                                    <span
                                      *ngIf="f.valor; else elseBlockFreteValor"
                                    >
                                      <span i18n>
                                        {{
                                          f.valor === 0
                                            ? "Grátis"
                                            : "R$" + f.valor
                                        }}
                                        - {{ f.label }} - {{ f.labelPrazo }}
                                      </span>
                                    </span>
                                    <ng-template #elseBlockFreteValor>
                                      <span>
                                        {{ f.label }}
                                        <span class="frete-gratis" i18n>
                                          -
                                          {{
                                            f.valor === 0
                                              ? "Grátis"
                                              : "R$" + f.valor
                                          }}
                                        </span>
                                        <div
                                          class="float-right"
                                          style="color: #888; font-size: 0.8rem"
                                        >
                                          {{ f.labelPrazo }}
                                        </div>
                                      </span>
                                    </ng-template>
                                  </div>
                                </div>
                              </ng-template>
                            </li>
                          </ul>
                          <!-- <select
                            *ngIf="fretes.retirar.length > 0"
                            id="retirar"
                            formControlName="freteId"
                            (change)="onFrete($event.target.value)"
                            class="form-control"
                            style="display: none; width: 100%"
                          >
                            <option
                              *ngFor="let f of fretes.retirar"
                              value="{{ f.id }}"
                              i18n
                            >
                              {{ f.valor === 0 ? "Grátis" : "R$" + f.valor }} -
                              {{ f.label }} - {{ f.prazo }} dias úteis
                            </option>
                          </select> -->

                          <!-- <ul id="retirar" class="list-group" style="cursor: pointer">
                            <li *ngFor="let f of fretes.retirar" style="padding: 0.25rem 0.5rem"
                              class="list-group-item list-group-item-action">
                              <div class="row">
                                <div class="col-1" style="padding: 0">
                                  <input name="retirar" value="{{ f.id }}" [formControl]="
                                      form.controls['freteIdRetirar']
                                    " style="width: 25px" type="radio" name="retirar" />
                                </div>
                                <div class="col">
                                  <span style="padding-left: 6px">{{ f.label }} - {{ f.prazo }} dias
                                    úteis</span>
                                </div>
                              </div>
                            </li>
                            <li style="padding: 0.25rem 0.5rem" class="list-group-item list-group-item-action">
                              <div class="row">
                                <div class="col-1" style="padding: 0">
                                  <input name="retirar" checked value="'11'" [formControl]="
                                      form.controls['freteIdRetirar']
                                    " style="width: 25px" type="radio" name="retirar" />
                                </div>
                                <div class="col">
                                  <span style="padding-left: 6px">teste dias úteis</span>
                                </div>
                              </div>
                            </li>
                          </ul> -->

                          <!-- <div class="d-flex row" *ngFor="let f of fretes.retirar">
                            <input type="radio" value="{{ f.id }}"/>
                            <label>
                              {{ f.valor === 0 ? "Grátis" : "R$" + f.valor }} -
                              {{ f.label }} - {{ f.prazo }} dias úteis
                            </label>
                          </div> -->

                          <ul id="retirar" style="padding: 0">
                            <li
                              style="padding: 0.5rem 0.75rem"
                              *ngFor="let f of fretes.retirar"
                              class="list-group-item list-group-item-action"
                              (click)="onFreteRetirar(f.id)"
                            >
                              <div *ngIf="f.error; else elseBlockFrete">
                                <span style="padding: 30px">{{
                                  f.message | json
                                }}</span
                                ><br />
                                <span style="padding: 30px">{{ f.label }}</span>
                              </div>
                              <ng-template #elseBlockFrete>
                                <input
                                  style="display: none !important; width: 25px"
                                  type="radio"
                                  value="{{ f.id }}"
                                  formControlName="freteId"
                                />
                                <div class="d-flex row">
                                  <div class="col-1">
                                    <div
                                      class="mt-1 {{
                                        form.controls.freteId.value == f.id
                                          ? 'selected-radio'
                                          : 'unselected-radio'
                                      }}"
                                    >
                                      <div
                                        *ngIf="
                                          form.controls.freteId.value == f.id
                                        "
                                        class="selected-radio-inside"
                                      ></div>
                                    </div>
                                  </div>
                                  <div class="col">
                                    <span
                                      *ngIf="f.valor; else elseBlockFreteValor"
                                    >
                                      <span i18n>
                                        {{
                                          f.valor === 0
                                            ? "Grátis"
                                            : "R$" + f.valor
                                        }}
                                        - {{ f.label }} - {{ f.prazo }} dias
                                        úteis
                                      </span>
                                    </span>
                                    <ng-template #elseBlockFreteValor>
                                      <span>{{ f.label }}</span>
                                    </ng-template>
                                  </div>
                                </div>
                              </ng-template>
                            </li>
                          </ul>
                        </div>
                        <!-- <div
                          *ngIf="error && form.get('freteId').invalid"
                          class="error"
                          i18n
                        >
                          Verifique este campo freteId!
                        </div> -->
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-lg-w pl-0">
                        <div class="form-group">
                          <label i18n>Nome</label>
                          <input
                            type="text"
                            formControlName="freteNome"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 pr-0">
                        <div class="form-group">
                          <label i18n>Sobrenome</label>
                          <input
                            type="text"
                            formControlName="freteSobrenome"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 pl-0">
              <div
                class="col-lg-12 mt-3 mb-3 pl-0"
                style="width: 100%; text-align: right"
              >
                <div *ngIf="SITE.mostraImpostoDetalhado" class="row">
                  <div class="col">Subtotal:</div>
                  <div class="col">
                    <span i18n>R$ {{ subTotal | currency : "BRL" : "" }}</span>
                  </div>
                </div>
                <div
                  *ngIf="acrescimoTotal"
                  class="row mb-1"
                  style="color: red; text-align: right"
                >
                  <div class="col" i18n>+ Acréscimos:</div>
                  <div class="col">
                    <span i18n
                      >R$ {{ acrescimoTotal | currency : "BRL" : "" }}</span
                    >
                  </div>
                </div>
                <div
                  *ngIf="descontoTotal"
                  class="row mb-1"
                  style="color: blue; text-align: right"
                >
                  <div class="col" i18n>- Descontos:</div>
                  <div class="col">
                    <span i18n
                      >R$ {{ descontoTotal | currency : "BRL" : "" }}</span
                    >
                  </div>
                </div>
                <div
                  *ngIf="SITE.mostraImpostoDetalhado"
                  class="div-checkout-imposto"
                >
                  <div
                    *ngIf="impostosTotal"
                    class="row mb-1"
                    style="color: red"
                  >
                    <div
                      class="col"
                      style="
                        color: red;
                        text-align: center;
                        margin-right: 115px;
                      "
                      i18n
                    >
                      + Impostos:
                    </div>
                  </div>
                  <div
                    *ngFor="let imposto of impostos"
                    class="row"
                    style="color: red; text-align: right"
                  >
                    <div
                      *ngIf="imposto.valor"
                      class="col"
                      style="color: red; text-align: rigth"
                    >
                      <span>{{ imposto.tipo + ": " }}</span>
                    </div>
                    <div *ngIf="imposto.valor" class="col">
                      <span i18n
                        >R$ {{ imposto.valor | currency : "BRL" : "" }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showFreteSum"
                  class="row mb-1"
                  style="color: red; text-align: right"
                >
                  <div class="col" i18n>+ Frete:</div>
                  <div *ngIf="tipoFrete == 1" class="col">
                    freteValors
                    <span>{{ form.controls.freteValor.value }}</span>
                  </div>
                  <div *ngIf="tipoFrete == 2" class="col">
                    <span i18n
                      >R$
                      {{
                        form.controls.freteValor.value | currency : "BRL" : ""
                      }}</span
                    >
                  </div>
                </div>
                <!-- <div class="row mt-2"> -->
                <div class="row justify-content-center">
                  <div class="col">
                    <span style="font-size: 1rem; font-weight: bold" i18n
                      >Valor total:</span
                    >
                  </div>
                  <div class="col">
                    <span class="money2" i18n
                      >R$ {{ valorTotal | currency : "BRL" : "" }}</span
                    >
                  </div>
                </div>

                <!-- </div> -->
              </div>
              <div
                class="col-lg-12 mt-3 mb-3 pl-0"
                style="width: 100%; text-align: right"
              >
                <button
                  *ngIf="
                    !pedido.salvoCheckout &&
                    !isCartaoCredito() &&
                    (!isPix() || SITE.gera_pagamento_aprovacao) &&
                    this.subTotal >= this.SITE.valorMinimoPedido
                  "
                  class="btn btn-primary btn-lg float-right"
                  style="font-size: 1.2rem !important"
                >
                  <i class="icofont-check-circled"></i> Finalizar
                </button>

                <button
                  class="btn btn-primary btn-lg float-right"
                  style="font-size: 1.2rem !important"
                  *ngIf="isPix() && !SITE.gera_pagamento_aprovacao"
                >
                  <i class="icofont-check-circled"></i>
                  Gerar Link de Pagamento
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <input type="text" id="inputLinkAprovaCliente" style="opacity: 0" />
</div>
<div
  class="modal fade"
  id="confirmDelModalModo2"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDelModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Confirma exclusão?</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button
          (click)="removeItemModo2()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="confirmDelModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDelModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente excluir?</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button
          (click)="removeItem()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="pixModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pixModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>QR code de pagamento</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="redirect()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body col mx-auto text-center">
        <img width="200" height="200" [src]="getSafeImageUrl()" />

        <span class="copy-btn" (click)="copyLink(qrCode.codigo_qrcode)">
          {{ qrCode.codigo_qrcode }} </span
        ><br />
        <button
          class="btn btn-success mt-2"
          (click)="copyLink(qrCode.codigo_qrcode)"
        >
          Copiar código
        </button>
      </div>
      <!-- <div class="modal-footer">
        <button
          (click)="removeItem()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div> -->
    </div>
  </div>
</div>
